import React from "react";
import {ReactComponent as TimeKeepingIcon} from "../../asset/icon/alarm.svg"
import {ReactComponent as CasualIcon} from "../../asset/icon/receipt_long.svg"
import {ReactComponent as SalaryIcon} from "../../asset/icon/paid.svg"
import {SubjectName} from "../../custom/permission/Ability";
import i18next from "i18next";
import {LineChartOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export const settingSiderData = (t) =>  [
    {
        label: t("tnp.components.common.text5"),
        key: "/setting/timekeeping/timekeeping-settings",
    },
    {
        label: t("tnp.components.common.text6"),
        key: "/setting/timekeeping/timesheet-formula",
    },
    {
        label: t("tnp.components.common.text7"),
        key: "/setting/timekeeping/shift-work",
        action: {
            label: t("tnp.components.common.text7"),
            type: "button",
            key: "/setting/timekeeping/shift-work/add",
            subjectName: SubjectName.tnp
        }
    },
    {
        label: t("tnp.components.common.text8"),
        key: "/setting/timekeeping/annual-leave",
        action: {
            label: t("tnp.components.common.text8"),
            type: "button",
            key: "/setting/timekeeping/annual-leave/add",
            subjectName: SubjectName.tnp
        }
    },
    {
        label: t("tnp.setting.settingGps"),
        key: "/setting/timekeeping/attendance-locations",
        action: {
            label: t("tnp.setting.gpsAction"),
            type: "button",
            key: "/setting/timekeeping/attendance-locations/add",
            subjectName: SubjectName.tnp
        }
    },
]

export const mainSiderData = (t) =>  [
    {
        key: "/hrm/timekeeping/time-sheet",
        name: "timeKeeping",
        icon: <TimeKeepingIcon style={{
            fontSize: "var(--primary-icon-size)",
            width: 22.39
        }}
        />,
        label: t("tnp.components.common.text9"),
        action: {
            subjectName: "timeKeeping",
            name: "timeKeeping",
            label: t("tnp.components.common.text9"),
            type: "buttons",
            children: [
                {
                    subjectName: "timeKeeping",
                    name: "timeKeeping",
                    key: "/hrm/timekeeping/time-sheet/shift-assignment/add",
                    label: t("tnp.components.common.text10"),
                    type: "button"
                },
                {
                    subjectName: "timeKeeping",
                    name: "timeKeeping",
                    key: "/hrm/timekeeping/time-sheet/auto-check-in-out",
                    label: t("tnp.components.common.text11"),
                    redirect: "/hrm/timekeeping/time-sheet/auto-check-in-out",
                    buttonType: "modal",
                    type: "button"
                },
            ]
        },
        children: [
            {
                label: t("tnp.components.common.text9"),
                key: "/hrm/timekeeping/time-sheet/timesheet",
            },
            {
                label: t("tnp.components.common.text12"),
                key: "/hrm/timekeeping/time-sheet/shift-registration",
            },
            {
                label: t("tnp.components.common.text10"),
                key: "/hrm/timekeeping/time-sheet/shift-assignment",
            },
            {
                label: t("tnp.components.common.text11"),
                key: "/hrm/timekeeping/time-sheet/auto-check-in-out",
            }
        ],
    },
    {
        key: "/hrm/timekeeping/casual-and-compensatory",
        name: "timeKeeping",
        icon: <CasualIcon
            style={{
                fontSize: "var(--primary-icon-size)",
                width: 24,
                padding: 0
            }}/>,
        label: t("tnp.components.common.text13"),
        children: [
            {
                label: t("tnp.components.common.text14"),
                key: "/hrm/timekeeping/casual-and-compensatory/casual-leave",
            },
        ],
    },
    {
        key: "/hrm/timekeeping/wage",
        name: "salaryTable",
        icon: <SalaryIcon
            style={{
                fontSize: "var(--primary-icon-size)",
                width: 24
            }}/>,
        label: t("tnp.components.common.text15"),
        action: {
            subjectName: "salaryTable",
            name: "salaryTable",
            label: t("tnp.components.common.text9"),
            type: "buttons",
            children: [
                {
                    subjectName: "salaryTable",
                    name: "salaryTable",
                    key: "/hrm/timekeeping/wage/template/add",
                    label: t("tnp.components.common.text16"),
                    type: "button"
                },
            ]
        },
        children: [
            {
                label: t("tnp.components.common.text15"),
                key: "/hrm/timekeeping/wage/table",
            },
            {
                label: t("tnp.components.common.payrollCustom"),
                key: "/hrm/timekeeping/wage/custom",
            },
            {
                label: t("tnp.components.common.text17"),
                key: "/hrm/timekeeping/wage/template",
            },
        ],
    },
    {
        key: "/hrm/timekeeping/report",
        name: "timeKeeping",
        icon: <LineChartOutlined
            style={{
                fontSize: "var(--primary-icon-size)",
                width: 24
            }}/>,
        label: t("tnp.components.common.text29"),

    }
]
export const defaultSiderData = (t) =>  {
    return {
        setting: [
            ...settingSiderData(t)
        ],
        main: [
            ...mainSiderData(t)
        ]
    }
}
